/**
 *
 * Routes
 *
 */

import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';
import NotFoundPage from 'components/EmptyState';
import Mixpanel from 'utils/mixpanelService';
import { isLocalhost } from 'utils/stringUtils';
import intercom from 'utils/intercomService';
import RoutesList from './Routes';

// eslint-disable-next-line react/prefer-stateless-function
export class Routes extends React.Component {
  penultimatePathname = null;

  antepenultimatePathname = null;

  componentDidMount() {
    this.penultimatePathname = document.referrer;
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    const { pathname } = location;
    const { location: prevLocation } = prevProps;
    const { pathname: prevPathname } = prevLocation;

    if (pathname !== prevPathname) {
      if (
        pathname.replace(
          /assessments\/(.+)\/page\d/,
          (_, p1) => `assessments/${p1}`,
        ) !==
        prevPathname.replace(
          /assessments\/(.+)\/page\d/,
          (_, p1) => `assessments/${p1}`,
        )
      ) {
        this.antepenultimatePathname = this.penultimatePathname;
        this.penultimatePathname = prevPathname;
        intercom.update();
      }
      this.trackPage(pathname);
      window.scrollTo(0, 0);
    }

    if (pathname === '/404') {
      Mixpanel.track('404 - Not Found', {
        path: this.penultimatePathname,
        prevPath: this.antepenultimatePathname,
      });
    }
  }

  trackPage = page => {
    if (!isLocalhost) {
      ReactGA.set({
        page,
      });
      ReactGA.pageview(page);
    }
  };

  render() {
    return (
      <Switch>
        {RoutesList.map(({ exact, path, component }, i) => (
          <Route exact={exact} path={path} component={component} key={i} />
        ))}
        <Route exact path="/404" component={NotFoundPage} />
        <Redirect to="/404" />
      </Switch>
    );
  }
}

Routes.propTypes = {
  location: PropTypes.object,
};

export default withRouter(Routes);
